const NAMESPACE = "automationRules";

const KEYS = {
    ProgramWideProjectRulesSectionHeader: "ProgramWideProjectRulesSectionHeader",
    ProgramWideActionRulesSectionHeader: "ProgramWideActionRulesSectionHeader",
    ValidationRulesSectionHeader: "ValidationRulesSectionHeader",
    ActionRulesSectionHeader: "ActionRulesSectionHeader",
    FormValidationRulesSectionHelpText: "FormValidationRulesSectionHelpText",
    StatusValidationRulesSectionHelpText: "StatusValidationRulesSectionHelpText",
    GenericValidationRulesSectionHelpText: "GenericValidationRulesSectionHelpText",
    ActionRulesSectionHelpText: "ActionRulesSectionHelpText"
};

const MESSAGES = {
    [KEYS.ProgramWideProjectRulesSectionHeader]: {
        value: "Program Wide Project Action Rules",
        comment: "Section header for program project rules"
    },
    [KEYS.ProgramWideActionRulesSectionHeader]: {
        value: "Program Action Rules",
        comment: "Section header for program rules"
    },
    [KEYS.ValidationRulesSectionHeader]: {
        value: "Validation Rules",
        comment: "Section header for validation rules"
    },
    [KEYS.ActionRulesSectionHeader]: {
        value: "Action Rules",
        comment: "Section header for action rules"
    },
    [KEYS.FormValidationRulesSectionHelpText]: {
        value:
            "Validation Rules are a type of Automation Rule that utilizes a formula to test a criterion of a data field. " +
            "Validation Rule formulas need to be Boolean formulas, or true/false formulas. " +
            'The formula should be structured such that the criteria that needs to be met will resolve as "true" when the data field has passed the validation test. ' +
            'If the formula resolves as "false", the validation rule will block form submission and allow an error message to display on the form to guide the user on how to resolve the invalid data entry.',
        comment: "Help text for the validation rule section"
    },
    [KEYS.StatusValidationRulesSectionHelpText]: {
        value:
            "Validation Rules are a type of Automation Rule that utilizes a formula to test a criterion of a data field. " +
            "Validation Rule formulas need to be Boolean formulas, or true/false formulas. " +
            'The formula should be structured such that the criteria that needs to be met will resolve as "true" when the data field has passed the validation test. ' +
            'If the formula resolves as "false", the validation rule will block the status change and allow an error message to display on the Current Status panel on the Project\'s Admin Page during status changes.',
        comment: "Help text for the validation rule section"
    },
    [KEYS.GenericValidationRulesSectionHelpText]: {
        value:
            "Validation Rules are a type of Automation Rule that utilizes a formula to test a criterion of a data field. " +
            "Validation Rule formulas need to be Boolean formulas, or true/false formulas. " +
            'The formula should be structured such that the criteria that needs to be met will resolve as "true" when the data field has passed the validation test. ' +
            'If the formula resolves as "false", the validation rule will block the action and display the error message.',
        comment: "Help text for the validation rule section"
    },
    [KEYS.ActionRulesSectionHelpText]: {
        value:
            "PowerClerk will attempt to process action rules in order. " +
            'If an action rule is successfully processed and has a "stop processing rules" property, PowerClerk will not attempt to process subsequent action rules. ' +
            "Certain action rules may need to be processed prior to subsequent action rules and must be ordered accordingly.",
        comment: "Help text for the action rule section"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
